'use strict'
import { initState } from './state'
import { promoteUrl } from "@/utils/url";
import Loader from '@/utils/loader'
import { searchHotThreadAPI, searchNameListAPI } from "@/api";

const actions = {
  // 重置
  reset ({ commit }) {

  },
  // 重置帖子搜索結果
  resetSearchThreadList({ commit }) {
    commit('setSearchThreadList', initState.searchThreadList)
  },
  // 重置用戶搜索結果
  resetSearchUserList({ commit }) {
    commit('setSearchUserList', initState.searchUserList)
  },
  // 搜索帖子
  async searchThread ({ state, rootGetters, commit, dispatch }, { keyword, sort, page = 1, pageSize = 20, reset = false }) {
    Loader.loading()
    if (page === 1 && reset) {
      dispatch('resetSearchThreadList')
    }
    const params = {
      keyword: btoa(encodeURI(keyword)),
      sort,
      page,
      perpage: pageSize
    }
    const { searchThreadListAPI } = await import('@/api/')
    const response = await searchThreadListAPI(params)
    Loader.cancel()
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        keyword, // 關鍵字
        sort, // 排序
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.searchThreadList.list, ...result.list]
        commit('setSearchThreadList', {
          ...result,
          list: collageList
        })
      } else {
        commit('setSearchThreadList', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },
  // 搜索用戶
  async searchUser ({ state, rootGetters, commit, dispatch }, { keyword, page = 1, pageSize = 20, reset = false }) {
    Loader.loading()
    if (page === 1 && reset) {
      dispatch('resetSearchUserList')
    }
    const params = {
      keyword: btoa(encodeURI(keyword)),
      page,
      perpage: pageSize
    }
    const { searchNameListAPI } = await import('@/api/')
    const response = await searchNameListAPI(params)
    Loader.cancel()
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        keyword, // 關鍵字
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.searchUserList.list, ...result.list]
        commit('setSearchUserList', {
          ...result,
          list: collageList
        })
      } else {
        commit('setSearchUserList', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },
  // 取得今日評論最高的帖子
  async searchHotThread({ state, rootGetters, commit }, { showError = false }) {
    Loader.loading()
    const params = {
      showError
    }
    const { searchHotThreadAPI } = await import('@/api/')
    const response = await searchHotThreadAPI(params)
    Loader.cancel()
    if (response?.body) {
      const result = {
        list: response.body || [],
      }
      // commit('setSearchUserList', result)
      return result
    } else {
      return response.head
    }
  },
}

export default actions
